// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__4L_Ti","title":"card_title__3rOTi","inActive":"card_inActive__1Yq4e"};